import { createSelector } from 'reselect';
import Immutable from 'immutable';
import { getUGCByType, getUGCListByUsers, getUGCByBibs } from './UGCBaseSelector';

const getTransactions = state => state.getIn(['ugc', 'quotationsTransactions'], Immutable.Map());

export const getQuotations = getUGCByType('quotations');
export const getQuotationsByUsers = getUGCListByUsers('quotations');
export const getQuotationsByBibs = getUGCByBibs('quotations');

export const getQuotationsTransactions = createSelector([getTransactions], (transactions) => transactions);

export default {
  getQuotations,
  getQuotationsByUsers,
  getQuotationsByBibs,
  getQuotationsTransactions
};



// WEBPACK FOOTER //
// ./app/selectors/ugc/QuotationsSelector.js